import { gsap, ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);

export default class Util {

	static windowWidth() {

		return document.documentElement.clientWidth;

	}

	static windowHeight() {

		return document.documentElement.clientHeight;

	}

	static isSmallWidth() {

		return (Util.windowWidth() <= 640);

	}

	static isIpadWidth() {

		return (Util.windowWidth() <= 768);

	}

	static isMobileWidth() {

		return (Util.windowWidth() <= 640);

	}

	static isMobile() {

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) 
		{
			return true;
		}
		 else
		{
			return false;
		}

	}

	static getMousePos (event) {

		let posx = 0;
		let posy = 0;

		if (!event)
		{
			event = window.event;
		}

		if (event.pageX || event.pageY)
		{
			posx = event.pageX;
			posy = event.pageY;
		}
		 else if (event.clientX || event.clientY)
		{
			posx = event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			posy = event.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		}

		return { x : posx, y : posy }

	}

	static setScrollTop (value) {

		document.documentElement.scrollTop = value;
		document.body.scrollTop = value;

	}

	static getScrollHeight() {

		return Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);

	}

	static getScrollTop() {

		return window.pageYOffset || document.documentElement.scrollTop || 0;

	}

	static scrollToTop() {

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;

	}

	static scrollToBottom() {

		const value = Util.getScrollHeight();

		document.documentElement.scrollTop = value;
		document.body.scrollTop = value;

	}

	static scrollToElement (selector, duration, callback, targets='html,body') {

		const element = document.querySelector(selector);

		if (element !== null)
		{
			const top = element.offsetTop;

			gsap.to(targets,
			{
				scrollTo: top,
				duration: duration,
				ease : 'power4.inOut',
				onComplete: () =>
				{
					// callback
					if (callback && typeof(callback) === 'function')
					{
						callback();
					}
				}
			});
		}

	}

	static debounce (callback, wait) {

		let timeout;

		return (...args) =>
		{
			clearTimeout(timeout);

			timeout = setTimeout(() =>
			{
				callback(...args);
			}, wait);
		};

	}

	static isInViewport (element) {

		const bounding = element.getBoundingClientRect();

		return (
			bounding.top >= 0 &&
			bounding.left >= 0 &&
			bounding.bottom <= (document.documentElement.clientHeight || window.innerHeight) &&
			bounding.right  <= (document.documentElement.clientWidth  || window.innerWidth)
		);

	}

	static isPartInViewport (element) {

		const bounding = element.getBoundingClientRect();

		const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
		const windowWidth  = (window.innerWidth || document.documentElement.clientWidth);

		const vertInView = (bounding.top  <= windowHeight) && ((bounding.top  + bounding.height) >= 0);
		const horInView  = (bounding.left <= windowWidth)  && ((bounding.left + bounding.width)  >= 0);

		return (vertInView && horInView);

	}

	static vignette (selector) {

		const elements = document.querySelectorAll(selector);

		for (let i = 0; i < elements.length; ++i)
		{
			const element = elements[i];

			const img = element.querySelector('img, svg');

			if (img !== null)
			{
				if (!img.getAttribute('data-original-width') && !img.getAttribute('data-original-height'))
				{
					const width = parseFloat(img.getAttribute('width') || 0);
					const height = parseFloat(img.getAttribute('height') || 0);

					img.setAttribute('data-original-width' , width);
					img.setAttribute('data-original-height', height);
				}

				const originalWidth = img.getAttribute('data-original-width');
				const originalHeight = img.getAttribute('data-original-height');
				const percent = Math.round((100*originalHeight)/originalWidth);

				element.style.paddingBottom = percent+'%';
			}
		}

	}

	static getAdaptedSize (maxWidth, maxHeight, width, height, isFullscreen) {

		const size = {'width': 0, 'height': 0};
		const ph = height / width;
		const pw = width / height;

		if ((width > 0) && (height > 0))
		{
			const condition = (isFullscreen)? ((maxHeight / maxWidth) < ph): ((maxHeight / maxWidth) > ph);

			if (condition)
			{
				size.width = maxWidth;
				size.height = Math.round(ph*maxWidth);
			}
			else
			{
				size.width = Math.round(pw*maxHeight);
				size.height = maxHeight;
			}
		}

		return size;

	}

	static getVideoElement (src, poster='', controls=false) {

		const videoEl = document.createElement('video');

		videoEl.classList.add('video');

		videoEl.muted = true;
		videoEl.loop = true;
		videoEl.autoplay = true;
		videoEl.setAttribute('playsinline', '');

		videoEl.poster = poster;
		videoEl.controls = controls;
		videoEl.src = src;

		return videoEl;

	}

	static addBlank (selector) {

		const elements = document.querySelectorAll(selector);

		for (let i = 0; i < elements.length; ++i)
		{
			const element = elements[i];

			const anchors = element.querySelectorAll("a[href^='http://'], a[href^='https://']");

			for (let j = 0; j < anchors.length; ++j)
			{
				anchors[j].setAttribute('target', '_blank');
			}
		}

	}

	static removeAlt (selector) {

		const elements = document.querySelectorAll(selector);

		for (let i = 0; i < elements.length; ++i)
		{
			const element = elements[i];

			const imgs = element.querySelectorAll('img');

			for (let j = 0; j < imgs.length; ++j)
			{
				imgs[j].setAttribute('alt', '');
			}
		}

	}

	static disableContextMenu() {

		document.addEventListener('contextmenu', (e) => {
			e.preventDefault();
		});

	}

	static shuffle (array) {

		for (let i = array.length - 1; i > 0; i--)
		{
			const j = Math.floor(Math.random() * (i + 1));

			[array[i], array[j]] = [array[j], array[i]];
		}

		return array;

	}

	static getValue (value, defaultValue) {

		return (value !== undefined)? value : defaultValue;

	}

	static getNumberFromInterval (min, max) {

		return Math.floor(Math.random() * (max - min + 1) + min);
	}

	static cleanPath (path) {

		return path.split('#')[0];

	}

	static capitalize (string) {

		return string.charAt(0).toUpperCase() + string.slice(1);

	}

	static get (url) {

		return new Promise( (resolve, reject) =>
		{
			const xhr = new window.XMLHttpRequest();

			xhr.onreadystatechange = () =>
			{
				if (xhr.readyState === 4)
				{
					if (xhr.status === 200)
					{
						resolve(xhr.responseXML);
					}
					 else
					{
						reject(xhr);
					}
				}
			};

			xhr.open('GET', url, true);
			xhr.responseType = 'document';
			xhr.send();
		});

	}

}
